import {
  IOrgForm,
  ICharge,
  IContract,
  IPackage,
} from '@/types/org.d';
import { IPAGE } from '@/types/base.d';
import fetch from './index';

// ------------------ ORG-MANAGE 机构管理
// 获取机构list
const getOrgList = (params: IPAGE) => fetch.axios_admin.get('/org/page', { params });

// 添加机构
const addOrg = (data: IOrgForm) => fetch.axios_admin.post('/org', data);

// 修改机构
const editOrg = (data: IOrgForm) => fetch.axios_admin.put('/org', data);

// 删除机构
const removeOrg = (params: { id: string }) => fetch.axios_admin.remove(`/org/?id=${params.id}`);

// 重置机构密码
const resetOrgPwd = (params: { id: string }) => fetch.axios_admin.put(`/org/password/?orgPid=${params.id}`);

// 生成邀请码
const generateOrgCode = (data: { id: string }) => fetch.axios_admin.put(`/org/invitationCode/?id=${data.id}`);

// 添加充值/对充
const addCharge = (data: ICharge) => fetch.axios_admin.post('/org/wallet', data);

// 修改充值/对充
const editCharge = (data: ICharge) => fetch.axios_admin.put('/org/wallet', data);

// 添加对充
const addContra = (data: ICharge) => fetch.axios_admin.post('/org/wallet/contra', data);

// 修改对充
const editContra = (data: ICharge) => fetch.axios_admin.put('/org/wallet/contra', data);

// 添加合同
const addContract = (data: IContract) => fetch.axios_admin.post('org/contract', data);

// 修改合同
const editContract = (data: IContract) => fetch.axios_admin.put('org/contract', data);

// 获取模块列表
const getModule = (params: { orgPid: string }) => fetch.axios_admin.get(`org/modules/${params.orgPid}
`);

// 模块分配
const alloctModule = (data: FormData) => fetch.axios_admin.post('org/modules', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 获取课包
const getPackages = (params: { orgPid: string, courseTitle: string }) => fetch.axios_admin.get(`org/course/?orgPid=${params.orgPid}&courseTitle=${encodeURIComponent(params.courseTitle)}`);

// 课包分配
const alloctPackage = (data: IPackage) => fetch.axios_admin.post('org/course', data);

// 修改课包分配
const editPackage = (data: IPackage) => fetch.axios_admin.put('org/course', data);

// ------------------ ORG-OPERATE 机构信息
// 根据机构pid获取机构信息
const getOrgInfo = (params: { orgPid: string }) => fetch.axios_admin.get('/org/wallet', { params });

// 根据机构pid获取机构充值统计
const getOrgRecharge = (params: { orgPid: string }) => fetch.axios_admin.get('/org/wallet/recharge', { params });

// 根据机构pid获取机构消费统计
const getOrgCost = (params: { orgPid: string }) => fetch.axios_admin.get('/org/wallet/cost', { params });

// 根据机构pid参数及分页查询数据
const getOrgConsume = (params: IPAGE, orgPid: string, date: string) => fetch.axios_admin.get(`/org/wallet/simpleCost?orgPid=${orgPid}&date=${date}`, { params });

// 根据机构pid参数及分页查询账户的充值明细
const getOrgAccountRecharge = (data: IPAGE, orgPid: string) => fetch.axios_admin.get(`/org/wallet/rechargeDetails?orgPid=${orgPid}`, { data });

// 根据账户明细id获取退款扩展
const getRefundInfo = (params: { walletPid: string }) => fetch.axios_admin.get(`org/wallet/recharge/refund?walletPid=${params.walletPid}`);

// 根据机构pid参数及分页查询账户的消费明细
const getOrgAccountConsume = (params: IPAGE, orgPid: string) => fetch.axios_admin.get(`/org/wallet/consumeDetails?orgPid=${orgPid}`, { params });

// 根据记录id进行退费
const refund = (params: { consumePid: string }) => fetch.axios_admin.post(`org/wallet/refund/?consumePid=${params.consumePid}`);

// 根据机构pid获取机构合同记录
const getOrgContractList = (params: IPAGE, orgPid: string) => fetch.axios_admin.get(`/org/contract/page?orgPid=${orgPid}`, { params });

// 根据机构pid合同更改合同状态
const contractStatus = (params: { orgId: string, pid: string, status: number }) => fetch.axios_admin.put(`org/contract/status/?orgPid=${params.orgId}&pid=${params.pid}&type=${params.status}`);

// 根据合同pid获取合同附件图片
const getAttachment = (params: { contractPid: string }) => fetch.axios_admin.get(`org/contract/attachment?contractPid=${params.contractPid}`);

// 根据合同pid上传合同附件图片
const addAttachment = (params: FormData) => fetch.axios_admin.post('org/contract/attachment', params);

// 根据图片ids删除合同附件图片
const removeAttachment = (params: {ids: string[] }) => fetch.axios_admin.remove(`org/contract/attachment/?ids=${params.ids}`);

// 根据机构pid获取机构课包记录
const getOrgCourseList = (params: IPAGE, orgPid: string) => fetch.axios_admin.get(`/org/course/page?orgPid=${orgPid}`, { params });

// 根据机构pid课包pid启用/停用课包
const courseStatus = (params: { pid: string, status: number }) => fetch.axios_admin.put(`/org/course/status?pid=${params.pid}&status=${params.status}`);

// 查询试卷列表
const getExamList = (pid: string) => fetch.axios_admin.get(`/org/paper?pid=${pid}&title=`)

// 机构增加试卷
const addExam = (data: object) => fetch.axios_admin.post('/org/paper', data)

// 查询机构的试卷列表
const getOrgPaperList = (params: IPAGE, orgPid: string) => fetch.axios_admin.get(`/org/paper/page?pid=${orgPid}`,{ params });

// 切换试卷状态(启用/激活)
const togglePaperStatus = (data: object) => fetch.axios_admin.put(`/org/paper`, data)

// 删除
const removePaperList = (pid: string) => fetch.axios_admin.remove(`/org/paper?pid=${pid}`)

export default {
  getOrgList,
  addOrg,
  editOrg,
  removeOrg,
  resetOrgPwd,
  generateOrgCode,
  addCharge,
  editCharge,
  addContra,
  editContra,
  addContract,
  editContract,
  getModule,
  alloctModule,
  getPackages,
  alloctPackage,
  editPackage,
  getOrgInfo,
  getOrgRecharge,
  getRefundInfo,
  getOrgCost,
  getOrgConsume,
  getOrgAccountRecharge,
  getOrgAccountConsume,
  getOrgContractList,
  refund,
  contractStatus,
  getAttachment,
  addAttachment,
  removeAttachment,
  courseStatus,
  getOrgCourseList,
  getExamList,
  addExam,
  getOrgPaperList,
  togglePaperStatus,
  removePaperList,
};
